import React, { useState } from "react";
import {
  ArrowLeft,
  ArrowRight,
  Building2,
} from "lucide-react";

import AppButton from "../../components/common/appButton/AppButton";
import AppInput from "../../components/common/appinput/AppInput";
import RoleToggle from "../../components/common/roleToggle/RoleToggle";

import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../config/config";
import axios from "axios";
import { message } from "antd";

const Login = () => {
  const [role, setRole] = useState("customer");

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({
  email: "",
  password: "",
});
const navigate = useNavigate()
  const handleSubmit = async (e) => {
  e.preventDefault();

  const newErrors = {
    email: "",
    password: "",
  };

  if (!email.trim()) {
    newErrors.email = "Email address is required";
  } else if (
    !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  ) {
    newErrors.email = "Please enter a valid email address";
  }

  if (!password.trim()) {
    newErrors.password = "Password is required";
  }

  setErrors(newErrors);

  if (newErrors.email || newErrors.password) {
    return;
  }

  try {
    setLoading(true);

    const payload = {
      email,
      password,
    };
    if(role === "customer"){
      const response = await axios.post(`${BASE_URL}/investor/login`,payload);
      message.success("OTP Sent SuccessFully")
      if(response?.data){
        {
        navigate("/otp",
          {state: {
              email: email || "",
              role:role
            }})
      }
      // console.log("otp :", response?.data?.otp);
      // message.info(response?.data?.otp)
      }
    }else{
      const response = await axios.post(`${BASE_URL}/owner/login`,payload);
      if(response?.data){
        message.success("OTP Sent SuccessFully")
        {
        navigate("/otp",
          {state: {
              email: email || "",
              role:role
            }})
      }
      }
      console.log("otp :", response?.data?.otp);
      // message.info(response?.data?.otp)
    }

  } catch (error) {
    console.log("Login failed:", error);
    message?.error(error?.response?.data?.detail || "Something Went Wrong")
  } finally {
    setLoading(false);
  }
};

  const handleGoogleLogin = () => {
    console.log("Google login", { role });
  };

  const handleForgotPassword = () => {
    console.log("Forgot password");
  };

  const handleCreateAccount = () => {
    console.log("Create account");
    navigate("/signup");
  };

  return (
    <main className="min-h-screen w-full overflow-hidden bg-white text-[#1f2318]">
      <section className="flex min-h-screen w-full overflow-hidden bg-white lg:grid lg:grid-cols-[55.5%_44.5%]">
        <div className="relative hidden min-h-[560px] overflow-hidden lg:block lg:min-h-screen">
          <img src="https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=1600&q=85" alt="Modern UAE real estate property" className="absolute inset-0 h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#1b2815]/10 via-[#172114]/20 to-[#172114]/80" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#172114]/20 via-transparent to-transparent" />

          <div className="absolute left-8 top-8 z-10 flex items-center gap-2 sm:left-10 sm:top-9">
            <div className="flex h-8 w-8 items-center justify-center rounded-lg border border-white/35 bg-white/15 text-white backdrop-blur-md"><Building2 size={15} strokeWidth={2.2} /></div>
            <span className="text-[14px] font-semibold tracking-[-0.01em] text-white">Real Estate</span>
          </div>

          <div className="absolute right-8 top-8 z-10 rounded-full border border-white/25 bg-white/10 px-3 py-1.5 text-[9px] font-semibold uppercase tracking-[0.12em] text-white backdrop-blur-md sm:right-10 sm:top-9">UAE REAL ESTATE</div>

          <div className="absolute bottom-7 left-8 right-8 z-10 sm:bottom-9 sm:left-10 sm:right-10 lg:bottom-10">
            <div className="mb-2 text-[9px] font-bold uppercase tracking-[0.17em] text-[#dce8cf] sm:text-[13px]">
              {role === "customer" ? "Fractional real estate in the UAE" : "Built for UAE property owners"}
            </div>
            <h1 className="max-w-[650px] font-['Playfair_Display'] text-[40px] font-normal leading-[1.04] tracking-[-0.025em] text-white sm:text-[46px] lg:text-[48px]">
              {role === "customer" ? <>Invest in Real Estate<br />
              <span className="gap-2 text-[30px] font-medium tracking-[0.025em] italic">Build your future</span></> : <>List your property.<br /><span className="italic font-medium">Reach more investors.</span></>}
            </h1>
            <p className="mt-3 max-w-[470px] text-[14px] leading-[1.6] text-white/75 sm:text-[12px]">
              {role === "customer" ? "Carefully selected property opportunities. Your portfolio, one simple dashboard." : "Bring your property, showcase its potential to investors, and manage your listings from one simple dashboard."}
            </p>
            <div className="mt-6 grid max-w-[500px] grid-cols-[1fr_auto_1fr_auto_1fr] items-center rounded-[12px] border border-white/15 bg-[#171e23]/60 px-3 py-2.5 backdrop-blur-xl sm:px-4 sm:py-3">
              <div className="text-center"><strong className="block text-[13px] font-semibold text-white">AED</strong><span className="mt-1 block text-[9px] uppercase tracking-[0.08em] text-white/50">UAE currency</span></div>
              <span className="h-7 w-px bg-white/15" />
              <div className="text-center"><strong className="block text-[13px] font-semibold text-white">UAE</strong><span className="mt-1 block text-[9px] uppercase tracking-[0.08em] text-white/50">Property market</span></div>
              <span className="h-7 w-px bg-white/15" />
              <div className="text-center"><strong className="block text-[13px] font-semibold text-white">Digital</strong><span className="mt-1 block text-[9px] uppercase tracking-[0.08em] text-white/50">Account access</span></div>
            </div>
          </div>
        </div>

        <div className="flex min-h-screen w-full items-center justify-center bg-white px-6 py-10 sm:px-12 lg:min-h-screen lg:px-14 xl:px-16">
          <div className="w-full max-w-[390px]">
            <div className="mb-8">
    <button
      type="button"
      onClick={() => navigate("/home")}
      className="group inline-flex items-center gap-1.5 rounded-full border border-[#e1e5df] bg-white px-3.5 py-2 text-[10px] font-medium text-[#657064] shadow-[0_4px_16px_rgba(47,68,36,0.05)] transition hover:border-[#b8caa8] hover:text-[#4c7a2e] "
    >
      <ArrowLeft
        size={14}
        strokeWidth={1.8}
        className="transition-transform duration-200 group-hover:-translate-x-0.5"
      />
      <span>Back to Home</span>
    </button>
  </div>
            <div className="mb-6">
              <div className="mb-4 inline-flex rounded-full border border-[#cddcbd] bg-[#f0f6ea] px-3 py-1.5 text-[9px] font-semibold uppercase tracking-[0.14em] text-[#4c7a2e]">Welcome back</div>
              <h2 className="font-['Playfair_Display'] text-[31px] font-normal leading-[1.02] tracking-[-0.025em] text-[#183240] sm:text-[34px]">Sign in </h2>
              <p className="mt-2 max-w-[340px] text-[11px] leading-[1.55] text-[#899087]">Access your real estate dashboard, investments, properties, and account activity.</p>
            </div>

            <div className="mb-5 rounded-[9px] border border-[#dfe3e0] bg-[#f3f4f3] p-[3px]"><RoleToggle role={role} onChange={setRole} /></div>

            <form className="flex flex-col gap-4" onSubmit={handleSubmit} noValidate>
              <AppInput label="Email Address" required type="email" name="email" value={email} onChange={(e) => { setEmail(e.target.value); if (errors?.email) setErrors((prev) => ({ ...prev, email: "" })); }} error={errors?.email} placeholder="you@example.com" autoComplete="email" />
              <AppInput label="Password" required type="password" name="password" value={password} onChange={(e) => { setPassword(e.target.value); if (errors?.password) setErrors((prev) => ({ ...prev, password: "" })); }} placeholder="Enter your password" autoComplete="off" showPasswordToggle showPassword={showPassword} onTogglePassword={() => setShowPassword((prev) => !prev)} error={errors?.password} />
              <div className="mt-[-2px] flex justify-end"><button type="button" onClick={handleForgotPassword} className="border-none bg-transparent p-0 text-[10px] font-medium text-[#4c7a2e] hover:underline">Forgot password?</button></div>
              <AppButton type="submit" loading={loading}>Sign in as {role === "customer" ? "Investor" : "Property Owner"}<ArrowRight size={15} className="ml-1.5" /></AppButton>
            </form>

            <div className="my-5 flex items-center gap-3"><span className="h-px flex-1 bg-[#e6e8e4]" /><span className="text-[9px] font-medium uppercase tracking-[0.15em] text-[#b0b3aa]"></span><span className="h-px flex-1 bg-[#e6e8e4]" /></div>
            <div className="space-y-4 text-center">
              <div className="text-[11px] text-[#92968e]">Don't have an account? <button type="button" onClick={handleCreateAccount} className="inline-flex items-center gap-1 border-none bg-transparent p-0 font-semibold text-[#4c7a2e] hover:underline">Create account <ArrowRight size={11} /></button></div>
              <div className="text-[11px] text-[#92968e]">I am an Admin? <button type="button" onClick={() => navigate("/mainAdmin/login")} className="inline-flex items-center gap-1 border-none bg-transparent p-0 font-semibold text-[#4c7a2e] hover:underline">Sign In <ArrowRight size={11} /></button></div>
            </div>
            {/* <div className="mt-6 flex items-center justify-center gap-1.5 text-[9px] text-[#a4a89f]"><span className="flex h-4 w-4 items-center justify-center rounded-full border border-[#ccd7c3] text-[#6a7847]">✓</span>Secure access to your Terra account</div> */}
          </div>
        </div>
      </section>
    </main>
  );
};

export default Login;

